import { Container } from '@/components'
import { Banner } from '@/components/about-us'
import { useTranslation } from '@/utils/hook'

const AboutUs = (): JSX.Element => {
  const t = useTranslation()

  return (
    <Container
      url="/about-us"
      title={t('metadata.aboutUs.title')}
      description={t('metadata.aboutUs.description')}
    >
      <Banner />
    </Container>
  )
}

export default AboutUs
